<template lang="pug">
  div.box
    v-server-table(
    :url="datatable.api"
    :name="datatable.name"
    :columns="datatable.columns"
    :options="datatable.options"
    ref="datatable"
    )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';
import types from './payment-types';

const TableName = 'VUETABLE_PAYMENT';

export default {
    data() {
        let canManagePayments = Auth.hasPermissionTo(
            'franchise_manage_payments',
        );

        let actionButtons = [
            {
                title: 'Restore Payment',
                action: () => this.showDeletedPayment(),
            },
            {
                title: 'Create Payment',
                action: () => this.showPopupForm(),
            },
            {
                title: 'Add SlurpPay',
                action: [
                    /*
                    {
                        title: 'AliPay',
                        callback: () => this.addCustomPayment('ipay_234'),
                    },
                    */
                    {
                        title: 'Boost',
                        callback: () => this.addCustomPayment('boost'),
                    },
                    /*
                    {
                        title: 'GHL',
                        callback: () => this.addCustomPayment('ghl'),
                    },
                    */
                    {
                        title: 'GoBiz',
                        callback: () => this.addCustomPayment('sunmi_gobiz'),
                    },
                    {
                        title: 'iPay',
                        callback: () => this.addCustomPayment('sunmi_ipay'),
                    },
                    {
                        title: 'Maybank QRPay',
                        callback: () => this.addCustomPayment('maybank_qrpay'),
                    },
                    {
                        title: 'Mobility One',
                        callback: () => this.addCustomPayment('m1_payment'),
                    },
                    {
                        title: 'MPay',
                        callback: () => this.addCustomPayment('mpay'),
                    },
                    {
                        title: 'TouchNGo',
                        callback: () => this.addCustomPayment('touch_n_go'),
                    },
                    {
                        title: 'Adaptis',
                        callback: () => this.addCustomPayment('ntt'),
                    },
                    /*
                  {
                      title: 'TouchNGo',
                      callback: () => this.addCustomPayment('ipay_336'),
                  },
                  {
                      title: 'Unionpay',
                      callback: () => this.addCustomPayment('ipay_338'),
                  },
                  {
                      title: 'WechatPay CN',
                      callback: () => this.addCustomPayment('ipay_305'),
                  },
                  {
                      title: 'WechatPay MY',
                      callback: () => this.addCustomPayment('ipay_343'),
                  },
                  */
                ],
            },
        ];

        if (!canManagePayments) {
            actionButtons = [];
        }

        return {
            datatable: {
                api: Laroute.route('franchise.setting.payment.index'),
                name: TableName,
                columns: ['name', 'type', 'outlets'],
                options: {
                    checkbox: canManagePayments,
                    checkbox_actions: {
                        api_delete: Laroute.route(
                            'franchise.setting.payment.delete',
                        ),
                        delete_title: 'Delete Payments',
                    },
                    sortable: ['name', 'type'],
                    orderBy: {
                        column: 'name',
                        ascending: 1,
                    },
                    customFilters: ['outlets', 'types'],
                    initFilters: {
                        outlets: [],
                        types: [],
                    },
                    actionButtons: actionButtons,
                    rowClassCallback: row => 'pointer',
                    rowClickCallback: this.showPaymentForm,
                    templates: {
                        type(h, row) {
                            let type = types.find(obj => obj.type === row.type);

                            if (type !== undefined) {
                                return type.name;
                            }

                            return '';
                        },

                        outlets(h, row) {
                            return require('./outlets.jsx')(h, row);
                        },
                    },
                },
            },
            payment: null,
        };
    },

    computed: {
        ...mapGetters('payment', ['filterOutlets', 'filterTypes']),
    },

    watch: {
        filterOutlets: function(o, n) {
            if (o === n) {
                // For some reason this is called even though there was no changes
                return;
            }

            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlets',
                value: this.filterOutlets,
            });
        },

        filterTypes: function(o, n) {
            if (o === n) {
                return;
            }

            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'types',
                value: this.filterTypes,
            });
        },
    },

    mounted() {
        this.focusSearch();
    },

    methods: {
        ...mapActions('payment', ['getPaymentBySource']),

        addCustomPayment(payment) {
            this.showPopupForm({
                type: 4,
                source: payment,
                require_reference: true,
                meta: {},
                outlets: [],
            });
        },

        focusSearch() {
            this.$nextTick(() => {
                $(this.$el)
                    .find('.VueTables__search-field input')
                    .focus();
            });
        },

        refresh() {
            this.$refs.datatable.getData();
        },

        showPaymentForm(payment = null) {
            if (payment !== null) {
                this.showPopupForm(payment);
            }
        },

        showPopupForm(payment = null) {
            this.$emit('payment-clicked', payment);
        },

        showDeletedPayment() {
            window.location.href = Laroute.route(
                'franchise.setting.payment.restore',
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/settings-payment-datatable.vue